import { createSlice } from "@reduxjs/toolkit";
import {
	clearInstoreDefaultPharmacist,
	saveInstoreDefaultPharmacist
} from "../../apis/auth/saveInstoreDefaultPharmacist";

const initialState = {
	loading: false,
	data: null,
	error: null
}

const saveInstoreDefaultPharmacistSlice = createSlice({
	name: 'saveInstoreDefaultPharmacist',
	initialState,

	extraReducers: (builder) => {
		builder.addCase(saveInstoreDefaultPharmacist.pending.type, (state) => {
			return {
				...state,
				loading: true,
				error: null
			}
		})

		builder.addCase(saveInstoreDefaultPharmacist.fulfilled.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			}
		})

		builder.addCase(saveInstoreDefaultPharmacist.rejected.type, (state, action) => {
			return {
				...state,
				loading: false,
				error: action.payload
			}
		})

		builder.addCase(clearInstoreDefaultPharmacist.pending.type, (state) => {
			return {
				...state,
				loading: true,
				error: null
			}
		})

		builder.addCase(clearInstoreDefaultPharmacist.fulfilled.type, (state, action) => {
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			}
		})

		builder.addCase(clearInstoreDefaultPharmacist.rejected.type, (state, action) => {
			return {
				...state,
				loading: false,
				error: action.payload
			}
		})
	}
})

export default saveInstoreDefaultPharmacistSlice.reducer
